import useSWR from 'swr';
import api from 'api/api';
import {
  checkIfNeedsToGetEta,
  driverIsDelayed,
  getIndexOfStopInProgress,
  getStopInProgress,
} from 'utils/driverEta';
import { useMemo } from 'react';
import apiUtils from 'api/utils';
import moment from 'moment-timezone';
import { useOrder } from 'hooks/useOrders';

const getEtaUrl = (stopInProgress, order) => {
  if (!stopInProgress || !checkIfNeedsToGetEta(order)) {
    return null;
  }
  const driverId = order.drivers?.[0]?.id;
  const address = stopInProgress.address;
  const { city, zipcode, address_line: addressLine, country } = address || {};
  const queryString = apiUtils.queryString({
    city,
    zipcode,
    address_line: addressLine,
    country_code: country,
    driver_id: driverId,
  });
  return `shipper-app/traceability/get_eta/?${queryString}`;
};

const processEta = (eta, stopInProgress, stops) => {
  if (!eta) {
    return null;
  }
  const { time_to: stopTime, time_to_tz: stopTz } = stopInProgress;
  const etaTime = moment(eta).tz(stopTz);
  const timeTo = moment(stopTime).tz(stopTz);

  return {
    eta: etaTime,
    stopIndex: getIndexOfStopInProgress(stops),
    isDelayed: driverIsDelayed({ eta: etaTime, timeTo: timeTo }),
  };
};

export const useOrderEta = (orderId, isRecurring) => {
  const { order } = useOrder(orderId, isRecurring);
  const stopInProgress = useMemo(
    () => getStopInProgress(order?.stops),
    [order?.stops]
  );
  const url = useMemo(() => {
    return getEtaUrl(stopInProgress, order);
  }, [stopInProgress, order]);
  const { data, error } = useSWR(url, api.getInstance().get, {
    refreshInterval: 30000,
    errorRetryInterval: 5000,
    errorRetryCount: 5,
  });
  const eta = useMemo(() => {
    return processEta(data?.data?.eta, stopInProgress, order?.stops);
  }, [order?.stops, stopInProgress, data]);

  return {
    eta,
    error,
    isLoading: !data,
  };
};
